import { render, staticRenderFns } from "./TransferMoneyAgent.vue?vue&type=template&id=f1bd3290&"
import script from "./TransferMoneyAgent.vue?vue&type=script&lang=js&"
export * from "./TransferMoneyAgent.vue?vue&type=script&lang=js&"
import style0 from "./TransferMoneyAgent.vue?vue&type=style&index=0&id=f1bd3290&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports